module.exports = __webpack_public_path__ + "static/media/work-directions-bg.3818d902.png";